import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Sort = ({ upActive, downActive, activeColor, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 28 28">
    <path
      fill={upActive ? activeColor : 'currentColor'}
      transform="translate(10 5.5)"
      id="up"
      d="m0.15491 5.5462 3.2136-4.6957c0.3216-0.46889 0.98-0.46718 1.2992 0.0042626l3.1792 4.6931c0.3824 0.56352 0.0032 1.3504-0.6496 1.3512l-6.3936 8.5252e-4c-0.656 0-1.0344-0.79029-0.6488-1.3538"
    />
    <path
      fill={downActive ? activeColor : 'currentColor'}
      transform="translate(10 15.5)"
      id="down"
      d="m7.8448 1.4538-3.2136 4.6956c-0.3208 0.46888-0.9792 0.46717-1.2992-0.0042625l-3.1792-4.693c-0.3824-0.5635-0.0032-1.3504 0.6504-1.3512l6.3928-8.525e-4c0.656 0 1.0344 0.79027 0.6488 1.3538"
    />
  </SvgIcon>
);

export default Sort;
